import React from 'react';
import Axios from 'axios';

// PLAYERS: Standard 9-ball standings - Single only
// ConfigIdx 0: Standard 
// ConfigIdx 1: Tailgators

// Constants for this standings
const cstTableHeaders = [
[	'Rang', 'Joueur', 'Cote', 'PJ', 'Vic', 'Def', 'V% ic', 'DIFF'],
[	'Rank', 'Player', 'PF', 'PA', 'DIFF', 'AVG', 'MP', 'Wins', 'Lost', 'Win %'],	// Tailgators
[	'Rang', 'Joueur', 'Cote', 'MJ', 'MG', '% MG', 'Vic', 'Def', '% Vic'],					// Qvnea 10B individuel
];

const cstDefaultSortOrder = [
[	'', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc'],
[	'', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc'],
[	'', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc']
];

const cstTeamFieldIdx = [99, 99, 99];

const cstFixedDecimalsStats = [
[
	{fieldIdx: 6, decimals: 2}
],[
	{fieldIdx: 5, decimals: 2},
	{fieldIdx: 9, decimals: 2}
],[
	{fieldIdx: 5, decimals: 1},
	{fieldIdx: 8, decimals: 1}
]];

// 									configs:     0  1  2
const cstDefaultSortFieldIdx1 = [4, 2, 5];
const cstDefaultSortFieldIdx2 = [1, 1, 8];
const cstDefaultSortFieldIdx3 = [1, 1, 1];

// Component
class PlayerStandings_9B_Sgl extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			configIdx: 0,
			tableHeaders: cstTableHeaders[0],
			teamFieldIndex: cstTeamFieldIdx[0],
			fixedDecimalsStats: cstFixedDecimalsStats[0],

			sortOrder: cstDefaultSortOrder[0][cstDefaultSortFieldIdx1[0]],
			sortFieldIdx: cstDefaultSortFieldIdx1[0],

			sortStandingIdx: 0,
			standings: [],
			standingsData: [],
			standingIdx: 0,
		};
	
		this.createSelectItem = this.createSelectItem.bind(this);
		this.standTypeChange = this.standTypeChange.bind(this);
		this.createStandingHdrRow = this.createStandingHdrRow.bind(this);
		this.createStandingRow = this.createStandingRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);	}

	componentDidMount() {
		this.initStandings(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.initStandings(nextProps);
	}

	initStandings(props) {
		// Standings
		var standings = props.standings;

		// console.log('props.standings');
		// console.log(props.standings);

		// Set Config Index according to stateloLeagueParam
		var configIdx = 0;
		if (props.season.stateloLeagueParam.indexOf('TAILGATORS-9BALL') !== -1) {
			configIdx = 1;
		}
		if (props.season.stateloLeagueParam.indexOf('QVNEA-INDIV-10B') !== -1) {
			configIdx = 2;
		}


		// ----------------------------------------------------------
		// SPECIAL CASES

		// Double and Individual Leagues of summer 2022
		// Sort by MG first
		if (props.season.stateloLeagueParam.indexOf('SORTMG') !== -1) {
			cstDefaultSortFieldIdx1[configIdx] = 4;
		}
		

		this.createStandingsData(standings, configIdx);

		this.setState({
			configIdx: configIdx,
			tableHeaders: cstTableHeaders[configIdx],
			teamFieldIndex: cstTeamFieldIdx[configIdx],
			fixedDecimalsStats: cstFixedDecimalsStats[configIdx],

			sortOrder: cstDefaultSortOrder[configIdx][cstDefaultSortFieldIdx1[configIdx]],
			sortFieldIdx: cstDefaultSortFieldIdx1[configIdx],

			standings: standings,
			standingIdx: props.standingIdx,
		});
	}

	createStandingsData(standings, configIdx) {
		var _this = this;
		var standingsData = [];

		// console.log('STANDINGS!   ConfigIdx:', configIdx);
		// console.log(standings[0].results);

		// Parse standings
		standings.forEach(function(standItem, standIdx) {

			var tableData = [];

			// Parse results
			standItem.results.forEach(function(result, resultIdx) {

				// Special conditions for Team column
				var teamCol = '';
				if (standItem.showTeam) {
					teamCol = result.teamName;
				}

				// Multiple players ?
				var playerNamesStr = '';
				var playerRatingStr = '';
				var delimChar = '';

				for (var idx = 0; idx < result.playersName.length; idx++) {
					if (idx !== 0) {
						delimChar = ' & ';
					}

					// QVNEA Leagues, show Rating Temp status
					var playerRatings = result.playersRating[idx].strValue;
					if (configIdx === 2) {
						playerRatings = result.playersRating[idx].strValueWithTemp;
					}

					playerNamesStr += delimChar + result.playersName[idx];
					playerRatingStr += delimChar + playerRatings;
				}

				var standingRow = [];

				switch(configIdx) {

					// STANDARD
					case 0:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						//standingRow.push(playerTRSStr);
						standingRow.push(playerRatingStr);
						standingRow.push(result.avg);
						standingRow.push(result.fp);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.ero);
						standingRow.push(result.eroContre);
						standingRow.push(result.dixzero);
						standingRow.push(teamCol);
						break;

					// TAILGATORS
					// 'Rank', 'Player', 'PF', 'PA', 'DIFF', 'AVG', 'MP', 'Wins', 'Lost', 'Win %'
					case 1:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						//standingRow.push(playerRatingStr);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.avg);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.pctWin);
						// standingRow.push(0);
						break;

					case 2:
						// // Qvnea 10B individuel
						// Rank', 'Player', 'TRS', 'MJ', 'MG', '% MG', 'Vic', 'Def', '% Vic'
						var pctWinGames = 0;
						var totalGames = result.pointsFor + result.pointsAgainst;
						if (totalGames > 0) {
							pctWinGames = Math.round((result.pointsFor / totalGames) * 10000) / 100;
						}

						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(playerRatingStr);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.gamesWon);
						standingRow.push(result.pctWin);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(pctWinGames);
						break;
				}

				tableData.push(standingRow);
			});

			standingsData.push(tableData);
		});

		var sortFieldIdx = cstDefaultSortFieldIdx1[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		// First data sort
		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});
	}

	resetAllSorting() {
		var _this = this;
		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;
		var sortFieldIdx = cstDefaultSortFieldIdx1[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});

		this.setState({
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder) {
		// console.log('sortOneStandingsData:', sortFieldIdx);
		// Manage empty data
		var _this = this;
		if (standingsItemData.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			standingsItemData.sort(function(a, b) {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;

				var fact1 = 0;
				var fact2 = 0;
				var fact3 = 0;

				// Criteria #1
				valueA = a[sortFieldIdx];
				valueB = b[sortFieldIdx];

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// test if string is numeric
				    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact1 = (sortSign * compVal);

				// Criteria #2
				valueA = a[cstDefaultSortFieldIdx2[configIdx]];
				valueB = b[cstDefaultSortFieldIdx2[configIdx]];

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// test if string is numeric
				    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact2 = (sortSign * compVal);

				// Criteria #3
				valueA = a[cstDefaultSortFieldIdx3[configIdx]];
				valueB = b[cstDefaultSortFieldIdx3[configIdx]];

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// test if string is numeric
				    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact3 = (sortSign * compVal);

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else if (fact2 !== 0) {
					return fact2;
				} else {
					return fact3;
				}
			});
		}

		// Reset Rank column
		if (standingsItemData[0] !== "") {
			standingsItemData.forEach(function(row, idx) {
				row[0] = idx + 1;
			});
		}

		var standingsData = this.state.standingsData;
		standingsData[standingsIdx] = standingsItemData;

		this.setState({
			standingsData: standingsData,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder
		});
	}

	render() {
		// console.log('STAND: PLAYERSTANDINGS RENDER (9B)');
		var standings = this.state.standings;
		return (
			<div>
				{(standings.length > 1) ? this.dispStandTypesSelector(standings) : null}
				<br/>
				{(standings.length !== 0) ? this.dispStandings(standings, this.state.standingIdx) : null}

				<div className="no-print">
				{(this.state.configIdx === 0) ? this.createLegend() : null}
				{(this.state.configIdx === 1) ? this.createLegend_TAILGATORS() : null}
				</div>
			</div>
		);
	}

	dispStandTypesSelector(standings) {
		return (
			<div className="row no-print">
			<div className="col-md-4">
				Options de classement
        <select className="form-control" value={this.state.standingIdx} onChange={this.standTypeChange}>
          {standings.map(this.createSelectItem)}
        </select>
			</div>
			</div>
		);
	}

  createSelectItem(standingsItem, standingsIdx) {
    return (
      <option value={standingsIdx} key={"stdType" + standingsIdx}>
      	{standingsItem.title}
      </option>
    );
  }

	standTypeChange(e) {
		this.resetAllSorting();
		this.setState({
			standingIdx: e.target.value
		});
		this.props.handleStandingIdxChange(e.target.value);
	}

	dispStandings(standings, standingsIdx) {
		var _this = this;
		var standingsItem = standings[standingsIdx];
		var standingsData = this.state.standingsData;

		return (
			<div className="row">
			<div className="col-md-12" key={'div.' + standingsIdx}>

				{/* NO-PRINT SECTION */}
				<div className="card no-print">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						{standingsItem.title.toUpperCase()}
					</div>

					<div className="card-body card-block">
						<div className="table-responsive tableFixHeader resizeVerticalStandings">
							<table className="table table-striped table-hover table-sm tableFix2col">
							<thead>
							<tr>
								{this.state.tableHeaders.map(function(elem, idx) {
									return _this.createStandingHdrRow(standingsIdx, elem, idx)
								})}
							</tr>
							</thead>
							<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
							</tbody>
							</table>
						</div>
			    </div>
				</div>

				{/* PRINT-ONLY SECTION*/}
				<div className="print-only">
					<h5>{standingsItem.title.toUpperCase()}</h5>
					<div className="table-responsive print-container">
						<table className="table table-striped table-sm">
						<thead>
						<tr>
							{this.state.tableHeaders.map(function(elem, idx) {
								return _this.createStandingHdrRow(standingsIdx, elem, idx)
							})}
						</tr>
						</thead>
						<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
						</tbody>
						</table>
					</div>
				</div>

		    </div>
		    </div>
		);
	}

	createStandingHdrRow(standingsIdx, hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

		// No header if no team (subs)
		if((this.state.standings[standingsIdx].showTeam === false) && (hdrIdx === this.state.teamFieldIndex)) {
			return;
		}
		if((this.props.formatTeamIndiv === "INDIV") && (hdrIdx === this.state.teamFieldIndex)) {
			return;
		}

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdx) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + standingsIdx + '.' + hdrIdx} 
				id={"colid." + standingsIdx + '.' + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

	createStandingRow(tableData, tableDataIdx) {
		return (
			<tr key={'te.' + tableDataIdx}>
				{tableData.map(this.createDataCell)}
      </tr>
    );
	}

	createDataCell(dataCell, dataCellIdx) {
		if((this.props.formatTeamIndiv === "INDIV") && (dataCellIdx === this.state.teamFieldIndex)) {
			return;
		}

		// Fixed number of decimals, converting to string, for averages or any other stats
		this.state.fixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		return (
			<td key={"tdcell." + dataCellIdx}>
				{dataCell}
			</td>
		);
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var _this = this;
		var standingsIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: sortFieldIdx,
		});

		this.sortOneStandingsData(configIdx, standingsData[standingsIdx], standingsIdx, sortFieldIdx, sortOrder);
	}

	createLegend() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
					
				<tbody>
				<tr key='leg1'>
					<td><b>TRS</b></td>
					<td>Cote TRS</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
					<td><b>VIC</b></td>
					<td>Victoires</td>
				</tr>
				<tr key='leg3'>
					<td><b>FP</b></td>
					<td>Facteur de Puissance</td>
					<td><b>DEF</b></td>
					<td>Défaites</td>
				</tr>
				<tr key='leg4'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg6'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg7'>
					<td><b></b></td>
					<td></td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_TAILGATORS() {
		// 'Rank', 'Player', 'PF', 'PA', 'DIFF', 'AVG', 'MP', 'Wins', 'Lost', 'Win %'
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
			<div className="card">
				<div className="card-header">
				<i className="fa fa-th-large"></i>
					LEGEND
				</div>

				<div className="card-block">
				<table className="table table-striped table-sm">				
				<tbody>
				<tr key='leg1'>
					<td><b>PF</b></td>
					<td>Points for</td>
					<td><b>MP</b></td>
					<td>Matches played</td>
				</tr>
				<tr key='leg2'>
					<td><b>PA</b></td>
					<td>Points against</td>
					<td><b>Wins</b></td>
					<td>Matches won</td>
				</tr>
				<tr key='leg3'>
					<td><b>DIFF</b></td>
					<td>Points for-against differential</td>
					<td><b>Lost</b></td>
					<td>Matches lost</td>
				</tr>
				<tr key='leg4'>
					<td><b>AVG</b></td>
					<td>Points average</td>
					<td><b>Win %</b></td>
					<td>Matches winning percentage</td>
				</tr>
					
				</tbody>
				</table>
				</div>

			</div>
			</div>

			{this.showPrintButton()}
{/*}
			<div className="col-md-12 col-xs-12">
				<h5>Informations complémentaires</h5>
				<ul>
					<li>Dans les cas où plusieurs TRS sont représentés pour un joueur, ils sont affichés du plus ancien au plus récent. </li>
					<li>Le Facteur de Puissance (FP) est calculé en tenant compte des PP, des VIC, des 10-0 et des ERO pour et contres</li>
					<li>L'Indice de Performance Statelo (IPS) est un nouveau calcul complexe, secret et évolutif qui tient compte de plusieurs statistiques</li>
				</ul>
			</div>
*/}
			</div>
		);
	}

	showPrintButton() {
		return (
			<div className="col-md-4 no-print">
				<button className="btn btn-secondary btn-sm btn-fluid pull-right" 
					onClick={this.printTable}> <i className="fa fa-print"></i>&nbsp;&nbsp;Imprimer le classement </button>

				<br/><br/>
				<div className="pull-right">
					<input type="checkbox" onChange={this.props.togglePrintLeagueMsg} checked={this.props.printLeagueMsg || false} />
					&nbsp;&nbsp;Imprimer le message de ligue
				</div>
			</div>
		)
	}

	printTable() {
		// replaceState remplace le URL affiché sur le printout
		var curURL = window.location.href;
		window.history.replaceState(history.state, '', '/');
		window.print();
		window.history.replaceState(history.state, '', curURL);
	}

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default PlayerStandings_9B_Sgl;
